import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement } from 'react';
interface IProps {
  action(): void;
  text: TranslationKey;
  icon: string;
  onMenuClose(): void;
}

export const SegmentationContextMenuItem = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const handleOnClick = (e: MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    props.action();
    props.onMenuClose();
  };

  const handleMouseUp = (e: MouseEvent<HTMLElement>): void => {
    e.preventDefault();
  };

  return (
    <div
      className='menu-item'
      onClick={handleOnClick}
      onMouseUp={handleMouseUp}
    >
      <div className={`menu-icon ${props.icon}`} /> {t(props.text)}
    </div>
  );
});
